<template>
  <div class="position-relative" v-if="!$route.meta.hideNavBar">
    <div class="img position-relative text-center" style="padding: 25%">
      <router-link to="/">
        <v-btn
          color="#20d876"
          icon="mdi-home"
          size="x-small"
          class="position-absolute top-0 right-0 ma-2 text-white"
          elevation="0"
        ></v-btn>
      </router-link>

      <h1 class="font text-h3 text-white" style="text-wrap: nowrap">
        كُن إِيجَابِي
      </h1>
    </div>
    <v-card
      max-width="97%"
      min-height="150"
      class="mx-auto"
      style="margin-top: -35px; border-radius: 20px"
      :elevation="3"
      ><v-row class="mt-3 pa-3">
        <v-col class="my-2">
          <router-link to="/adeia">
            <v-btn icon class="gradin" size="55">
              <img
                src="../assets/icons/hands.png"
                style="mix-blend-mode: screen"
                class="w-100 ml-1"
                alt=""
              />
            </v-btn>
          </router-link>
          <p class="mx-auto mt-2 font" style="color: #20d876">ادعية</p></v-col
        >
        <v-col class="my-2">
          <router-link to="/quran">
            <v-btn icon class="gradin" size="55">
              <img
                src="../assets/icons/quran.png"
                style="mix-blend-mode: screen"
                class="w-100"
                alt=""
              />
            </v-btn>
          </router-link>
          <p
            class="mx-auto mt-2 font"
            style="color: #20d876; text-wrap: nowrap"
          >
            القرأن الكريم
          </p></v-col
        >
        <v-col class="my-2">
          <router-link to="/ahadyth">
            <v-btn icon class="gradin" size="55">
              <img
                src="../assets/icons/book.png"
                style="mix-blend-mode: screen; margin-top: -7px"
                class="w-100 mx-auto"
                alt=""
              />
            </v-btn>
          </router-link>
          <p class="mx-auto mt-2 font" style="color: #20d876">احاديث</p></v-col
        >
        <v-col class="my-2">
          <router-link to="/eibarat">
            <v-btn icon class="gradin" size="55">
              <img
                src="../assets/icons/pen.png"
                style="mix-blend-mode: screen"
                class="w-100 pa-1"
                alt=""
              />
            </v-btn>
          </router-link>
          <p class="mx-auto mt-2 font" style="color: #20d876">عبارات</p></v-col
        >
      </v-row>
    </v-card>
  </div>
</template>
<style scoped>
.img {
  background-image: url("../assets/cover.png");
  background-size: cover;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
}
.gradin {
  background-color: #14c567;
}
</style>
